module.exports = __webpack_public_path__ + "static/media/SubstanceUse.087e1b8d.svg";